import { SmartyStreetsService } from "./implementations/smartystreets.service";

export default defineNuxtPlugin((nuxtApp) => {
  const st = new SmartyStreetsService(
    nuxtApp.$axios,
    nuxtApp.$config.public.smartyStreetsUrl,
    nuxtApp.$config.public.smartyStreetsAddressUrl,
    nuxtApp.$config.public.smartyStreetsApi
  );

  return {
    provide: {
      st: st,
    },
  };
});
